module.exports = __webpack_public_path__ + "static/media/20180524-LCS-019-14.e5c6f93e.jpg";